import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function GoogleCallback() {
  const navigate = useNavigate();
  const exchanged = useRef(false); // prevent double-fire in StrictMode

  useEffect(() => {
    if (exchanged.current) return;
    exchanged.current = true;

    const params = new URLSearchParams(window.location.search);
    const authCode = params.get("auth_code");

    if (!authCode) {
      alert("Login failed — no auth code received.");
      navigate("/");
      return;
    }

    api
      .post("/api/auth/exchange/", { auth_code: authCode })
      .then((res) => {
        const { name, email, picture } = res.data;
        // Store only non-sensitive profile info for UI display.
        // JWT tokens are in HttpOnly cookies (not accessible to JS).
        localStorage.setItem(
          "user",
          JSON.stringify({
            name: String(name || "").trim().slice(0, 150),
            email: String(email || "").trim().slice(0, 254),
            picture: String(picture || "").trim().slice(0, 500),
          })
        );
        navigate("/");
      })
      .catch(() => {
        alert("Login failed. Please try again.");
        localStorage.removeItem("user");
        navigate("/");
      });
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h3>Logging you in…</h3>
      <p>Please wait while we complete authentication.</p>
    </div>
  );
}
